import { default as _91_46_46_46slug_93ILszah2VNpMeta } from "/app/pages/[...slug].vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as _91jobId_93xGYqV6vaJnMeta } from "/app/pages/jobs/[jobTitleSlug]/[jobId].vue?macro=true";
import { default as searchfcnTL5fl5XMeta } from "/app/pages/search.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "jobs-jobTitleSlug-jobId",
    path: "/jobs/:jobTitleSlug()/:jobId()",
    component: () => import("/app/pages/jobs/[jobTitleSlug]/[jobId].vue").then(m => m.default || m)
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/app/pages/search.vue").then(m => m.default || m)
  }
]